import React from 'react'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useBreakpoints } from 'hooks'

const DropdownItem = ({ icon, to, children, className, ...rest }) => {
  const { md } = useBreakpoints()

  return (
    <NavLink
      to={to}
      activeClassName="text-white text-opacity-100"
      {...rest}
      className={classnames(
        'p-4 bg-transparent flex items-center text-white text-opacity-50 text-md leading-4 text-center hover:text-white md:px-6 md:text-left md:text-base',
        className
      )}
    >
      {md && icon}
      <span className="w-full md:ml-4">{children}</span>
    </NavLink>
  )
}

DropdownItem.propTypes = {
  to: PropTypes.string.isRequired,
  icon: PropTypes.element,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
  exact: PropTypes.bool,
}

export default DropdownItem
